"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardImage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("./styles");
var classnames_1 = require("classnames");
var CardImage = function (_a) {
    var orientation = _a.orientation, size = _a.size, headerVariation = _a.headerVariation, imageUrl = _a.imageUrl, imageTitle = _a.imageTitle, className = _a.className;
    if (!(['image', 'image-bg'].includes(headerVariation) && imageUrl)) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)((0, styles_1.getImageContainerVariantClass)(orientation, size, headerVariation), className) }, { children: (0, jsx_runtime_1.jsx)("img", { className: (0, styles_1.getImageVariantClass)(orientation, headerVariation), alt: imageTitle, src: imageUrl }) })));
};
exports.CardImage = CardImage;
